import {
    SkyNetSpreadSheetSort,
} from 'app/shared-components/SkyNetSpreadSheet/SkyNetSpreadSheet.types'

const defaultRateCardsBulkSort: SkyNetSpreadSheetSort = {
    sortField: 'id',
    sortType: 'desc',
}

export default defaultRateCardsBulkSort
